// Generated by Melange

import * as Atdgen_codec_decode from "melange-atdgen-codec-runtime/atdgen_codec_decode.js";
import * as Atdgen_codec_encode from "melange-atdgen-codec-runtime/atdgen_codec_encode.js";
import * as Buhta_models__Models from "../Models.js";

const write_receipt = Buhta_models__Models.Receipt.write_t;

const read_receipt = Buhta_models__Models.Receipt.read_t;

const write_etpOrder = Buhta_models__Models.EtpOrder.write_t;

const read_etpOrder = Buhta_models__Models.EtpOrder.read_t;

const write_t = Atdgen_codec_encode.make(function (t) {
  return Atdgen_codec_encode.obj({
    hd: Atdgen_codec_encode.field(undefined, write_receipt, "receipt", t.receipt),
    tl: {
      hd: Atdgen_codec_encode.field(undefined, write_etpOrder, "etpOrder", t.etpOrder),
      tl: /* [] */ 0
    }
  });
});

const read_t = Atdgen_codec_decode.make(function (json) {
  return {
    receipt: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("receipt", read_receipt, param);
    }), json),
    etpOrder: Atdgen_codec_decode.decode((function (param) {
      return Atdgen_codec_decode.field("etpOrder", read_etpOrder, param);
    }), json)
  };
});

export {
  read_receipt,
  write_receipt,
  read_etpOrder,
  write_etpOrder,
  read_t,
  write_t,
}
/* write_t Not a pure module */
